import { gql } from '@apollo/client';
import appraiserObservationReportFragment from './fragments/appraiserObservationReportReportFragment';

const GET_APPRAISER_OBSERVATION_REPORTS = gql`
  query GetAppraiserObservationReports($externalUserId: Int!) {
    appraiserObservationReports(externalUserId: $externalUserId) {
      AtmReports {
        ...AppraiserObservationReportFields
      }
      AtlReports {
        ...AppraiserObservationReportFields
      }
    }
  }
  ${appraiserObservationReportFragment}
`;

export default GET_APPRAISER_OBSERVATION_REPORTS;
